module.exports = __webpack_public_path__ + "2b4412b5b535c4ecc37f9721c3e279ed.png";